/**
 * @desc 新增角色
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.NewUserPreferences,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/role/addRole',
    data,
  });
}

export function mock(
  data: defs.NewUserPreferences,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/role/addRole',
    data,
  });
}
